import { useEffect, useState, useRef } from "react";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
/*Importaciones de react crop*/
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Footer from "./Footer";

const Registro = () => {
    const [idCuenta, setIdCuenta] = useState("");
    const [userId, setUserId] = useState("");
    const [name, setName] = useState("");
    const [lastname, setLastname] = useState("");
    const [validationIdCH ,setValidationIdCH] = useState(null);
    const [valueImage, setValueImage] = useState("");
    const [originalImage ,setOriginalImage] = useState("");
    const [image, setImage] = useState("");
    const [loaderCH, setLoaderCH] = useState(false);
    const [fileCrop, setFileCrop] = useState("");
    const [nameImage, setNameImage] = useState("");
    const [loaderSendForm, setLoaderSendForm] = useState(false);
    /*inicio crop*/
    const [cropData, setCropData] = useState("");
    const [cropper, setCropper] = useState(null);
    const cropperRef = useRef(null);
    const [croppedImage, setCroppedImage] = useState(false);

    useEffect(() => {
        console.log("cambio en variable");
        if(fileCrop == ""){
            fetch(cropData)
            .then(res => res.blob())
            .then(blob => {
                const file = new File([blob], "cropImage: " + nameImage, { type: "image/png" })
                if(croppedImage === true){
                    setFileCrop(file);
                    showToast("success","Imagen Recortada")
                }
            })
        }
    }, [cropData]);

    const getCropImage = (e) => {
        e.preventDefault()
        if (typeof cropper !== "undefined") {
            setCropData(cropper.getCroppedCanvas().toDataURL());
            setCroppedImage(true);
        }
    };

    const rotateImage = (e) => {
        e.preventDefault();
        const imageElement = cropperRef?.current;
        const cropper = imageElement?.cropper;
        cropper.rotate(30);
        setCropData(cropper.getCroppedCanvas().toDataURL());
        setCroppedImage(true);
    }

    function inputChanges(e) {
        e.preventDefault();
        if (e.target.id === "idCuenta") { setIdCuenta(e.target.value);  setValidationIdCH(false)}
        if (e.target.id === "name") { setName(e.target.value); }
        if (e.target.id === "lastname") { setLastname(e.target.value); }
        if (e.target.id === "picture") {
            let files = e.target.files || e.dataTransfer.files; 
            setValueImage(e.target.value);
            setNameImage(files[0].name);
            setOriginalImage(files[0]);
            const reader = new FileReader();
            reader.onload = () => {
                setImage(reader.result);
            };
            reader.readAsDataURL(files[0]);
        }
    }

    function showToast(typeToast, message ){
        let varToast;
        switch(typeToast) {
            case "success":
                varToast = toast.success;
              break;
            case "danger":
                varToast = toast.danger;
              break;
            case "error":
                varToast = toast.error;
              break;
            default: 
                varToast = toast.info
          }
        varToast(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    function validarIdCH() {
        if (idCuenta !== "") {
            setLoaderCH(true);
            axios({
                url: process.env.REACT_APP_API+"/api/users/account_num/" + idCuenta,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then((response) => {
                setLoaderCH(false);
                if (response.data.status === true) {
                    setValidationIdCH(true);
                    console.log("respuesta validacion id Cuenta Habiente: " + JSON.stringify(response.data.data));
                    showToast("success", "Id de cuenta Habiente correcto");
                    setUserId(response.data.data.id);
                    // Llena campos si es que traen algo
                    setName(response.data.data.name);
                    setLastname(response.data.data.lastname);
                } else {
                    setValidationIdCH(false);
                    showToast("error", "No existe el número de Cuentahabiente");
                }
            })
            .catch((e) => {
                console.error("error de axios " + e);
            })
        } else {
            showToast("info", "Llena el campo de cuentahabiente");
        }
    }

    function enviarImagenForm() {
        if(name === "" || lastname === "" || idCuenta === "" || valueImage.length === 0 || validationIdCH === false){
            showToast("info", "LLena todos los campos");
            return false;
        }
        else{
            console.log("archivo de imagen recortada: ", fileCrop);
            console.log("imagen original:", originalImage);
            let imagenFinal ;
            if(croppedImage === false){
                imagenFinal = originalImage;
            }else{
                imagenFinal = fileCrop;
            }
            var formData = new FormData();
            formData.append("image", imagenFinal);
            axios({
                url: process.env.REACT_APP_API+"/api/christmas/store-picture",
                method: 'POST',
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json'
                },
                data: formData,
            })
            .then((response) => {
                let img = response.data.filename;
                enviarDatosForm(img);
                console.log(response);
            })
            .catch((e) => {
                console.error(e);
            })
        }
    }

    function enviarDatosForm(img){
        console.log(img);
        setLoaderSendForm(true);
        let data = {
            "microsite_id": process.env.REACT_APP_SITE_ID,
            "user_id": userId,
            "history": null,
             "picture": img,
        }
        axios({
            url: process.env.REACT_APP_API+"/api/christmas",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data,
        })
        .then((response) => {
            console.log(response);
            if (response.data.status === true) {
                setLoaderSendForm(false);
                showToast("success", response.data.message);
                limpiarFormulario();
            } else if (response.data.status === false) {
                var mensajes = response.data.message;
                console.log(mensajes);
                if (typeof (mensajes) === "string") {
                    showToast("error", mensajes);
                } else {
                    console.log(typeof (mensajes))
                    mensajes = Object.entries(mensajes);
                    for (let i = 0; i < mensajes.length; i++) {
                        console.log(mensajes[i][1][0]);
                        showToast("error", mensajes[i][1][0]);
                    }
                }
            }
        })
        .catch((e) => {
            console.error(e);
        })
    }
    function limpiarFormulario(){
        console.log("Reestableciendo variables");
        setIdCuenta("");
        setUserId("");
        setName("");
        setLastname("");
        setValidationIdCH(null);
        setValueImage("");
        setOriginalImage("");
        setImage("");
        setLoaderCH(false);
        setFileCrop("");
        setNameImage("");
        setCropData("");
        setCropper(null);
        setCroppedImage(false);
        setLoaderSendForm(false);
    }
    return (
        <>
            <div className="fondoBases">
            <div className="container pb-5 contenedorRegistro">
                <ToastContainer />
                <div className="row d-flex justify-content-center pt-3">
                    <h1 className="text-center mt-5 mb-5 tituloBases text-uppercase">Registra tu arbolito</h1>
                    <form className="container">
                        <div className="row  justify-content-center">
                            <div className={(valueImage !== "")
                            ?
                            "col-md-6 justify-content-center customFormContainer"
                            :
                            "col-sm-12 justify-content-center customFormContainer"
                            }>
                                <label className="form-label">ID CuentaHabiente</label><br/>
                               
                                <div className="input-group mt-2">
                                    <label className="input-group-text" htmlFor="inputGroupSelect01">MD-</label>
                                    <input type="number" className={ 
                                        validationIdCH === true ? 'form-control border-success' 
                                        : validationIdCH === false ? 'form-control border-danger'
                                        : 'form-control'
                                    } 
                                        id="idCuenta" value={idCuenta} onChange={inputChanges} aria-describedby="button-addon2" />
                                        
                                    <button className={(validationIdCH === true) 
                                        ? 'btn btn-success border-2'
                                        : 'btn btn-danger border-2'
                                        } type="button" id="button-addon2" onClick={validarIdCH}>
                                            {(loaderCH === true)
                                            ?
                                                <div className="spinner-border text-light spinner-border-sm me-2" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                                </div>
                                            :
                                                ""
                                            }
                                            {   validationIdCH === true  ? 'Validado'
                                                : validationIdCH === false ? 'Validar'
                                                : 'Validar' 
                                            }
                                            {   validationIdCH === true  ? <span className="ps-2">✓</span>
                                                : validationIdCH === false ? <span className="ps-2"></span>
                                                : <span></span>
                                            }
                                    </button>
                                </div>
                                <a href="https://mmkg.net/registro" class="urlCuenta pb-3" target="_blank">Regístrate como CuentaHabiente</a>
                               <br/>
                               <br/>
                                <label className="form-label">Nombre</label>
                                <input type="text" className="form-control mb-3" id="name" value={name} onChange={inputChanges} disabled/>
                                <label className="form-label">Apellido</label>
                                <input type="text" className="form-control mb-3" id="lastname" value={lastname} onChange={inputChanges} disabled/>
                                <label htmlFor="picture" className="form-label">Agrega tu arbolito</label>

                                <div className="file-input">
                                    <input
                                        type="file"
                                        name="picture"
                                        id="picture"
                                        className="form-control mb-5 file-input__input"
                                        value={valueImage} onChange={inputChanges} accept="image/*" required
                                    />
                                    <label className="file-input__label" htmlFor="picture">
                                        <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fas"
                                        data-icon="upload"
                                        className="svg-inline--fa fa-upload fa-w-16"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        >
                                        <path
                                            fill="currentColor"
                                            d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                                        ></path>
                                        </svg>
                                        <span>{( valueImage.length === 0)
                                            ? "Subir imagen"
                                            : "Imagen agregada ✓"
                                        }</span></label>
                                </div>
                            </div>
                            {image !== "" 
                                ?
                            <div className="col-md-6 justify-content-center">
                                <div className="row mb-5">
                                        <div className="col-sm-12 px-5">
                                            <Cropper
                                                style={{ height: "auto", width: "auto" }}
                                                zoomTo={0.1}
                                                initialAspectRatio={1}
                                                preview=".img-preview"
                                                src={image}
                                                viewMode={1}
                                                minCropBoxHeight={10}
                                                minCropBoxWidth={10}
                                                background={false}
                                                responsive={true}
                                                movable={true}
                                                rotable={true}
                                                ref={cropperRef}
                                                autoCropArea={1}
                                                checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                                                onInitialized={(instance) => {
                                                    setCropper(instance);
                                                }}
                                                guides={true}
                                            />
                                            <div className="d-flex justify-content-around">    
                                                <button className="mt-3 btn btn-primary" onClick={getCropImage}> ✄ Cortar imagen</button>
                                                <button className="mt-3 btn btn-primary" onClick={rotateImage}>
                                                <svg xmlns="://www.w3.org/2000/svg" width="15" fill="white" className="me-2" viewBox="0 0 512 512"><path d="M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"/></svg>
                                                    Rotar Imagen
                                                    </button>
                                            </div>
                                        </div>
                                                {/*cropData !== ""
                                                    ? <>
                                                         {
                                                           showToast("success","Imagen Recortada")
                                                         }
                                                    </>
                                                    :
                                                    null*/
                                                }
                                          
                                    </div>
                                </div>
                                :
                                null
                                }
                        </div>
                        {(name === "" || lastname === "" || idCuenta === "" || valueImage.length === 0 || validationIdCH === false) 
                            ? <button type="button" className="btn btn-secondary mx-auto d-block" disabled={true}>Enviar</button> 
                            : <button type="button" className="btn btn-success mx-auto d-block" onClick={enviarImagenForm} disabled={false}>
                                {(loaderSendForm === true)
                                ?
                                    <div className="spinner-border text-light spinner-border-sm me-2" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                    </div>
                                :
                                    ""
                                }
                                {   loaderSendForm === true  ? 'Enviando'
                                    : loaderSendForm === false ? 'Enviar'
                                    : 'Enviar' 
                                }
                            </button> 
                        }
                    </form>
                </div>
            </div>
            </div>
            <Footer></Footer>
        </>
    )
}
export default Registro;